import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { callTokenApi } from '../../../../../../apiCaller';
import { API_CLIENT_SEGMENT_DETAil, TYPE_SHOW_UNSAVE_CHANGE } from '../../../../../../constants';
import CenterSpinner from '../../../../../general/Loadings/CenterSpinner';
import { toastError } from '../../../../../../utils';
import { setRuleHaveEditting } from '../../../../../../actions/common';
import { INITIAL_SEGMENT_GROUP, MAPPING_SF_SEGMENT_OBJECT, SEGMENT_OBJECT, SEGMENT_OBJECT_OPTIONS, isEventSegmentEnabled } from '../../../../../../constants/segment';
import PropTypes from 'prop-types';

const SegmentRuleStep = React.lazy(() => import(`./steps/SegmentRuleStep`));
const SegmentInfoStep = React.lazy(() => import(`./steps/SegmentInfoStep`));

export const SegmentDetailContext = React.createContext({});

const DEFAULT_DATA_SEGMENT = {
     name: '',
     description: '',
     ruleGroups: [INITIAL_SEGMENT_GROUP],
};
const SegmentDetail = ({ id }) => {
     const dispatch = useDispatch();
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const externalObjectReport = useSelector((state) => state.subscriber.externalObjectReport);
     const accountId = activeAccount.id;
     const crmSegmentObjectOptions = externalObjectReport.map(({ object, appearInReport }) => ({
          appearInReport,
          value: MAPPING_SF_SEGMENT_OBJECT[object] || object,
          label: `CRM ${object === 'Event' ? 'Activity Event' : object}`,
     }))
     const eventSegmentObjectOptions = isEventSegmentEnabled(accountId) ? [{ value: SEGMENT_OBJECT.EVENT, label: 'Event' }] : [];
     const allSegmentObjectOptions = [...eventSegmentObjectOptions, ...SEGMENT_OBJECT_OPTIONS, ...crmSegmentObjectOptions];

     const [isLoading, setIsLoading] = useState(false);
     const [activeStep, setActiveStep] = useState(1);
     const [stepsData, setStepsData] = useState(cloneDeep(DEFAULT_DATA_SEGMENT));
     const [initStepsData, setInitStepsData] = useState(cloneDeep(DEFAULT_DATA_SEGMENT));

     const fetchSegmentDetail = () => {
          if (!id) return;
          setIsLoading(true);
          callTokenApi(API_CLIENT_SEGMENT_DETAil.replace(':accountId', accountId).replace(':id', id), 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         const { segment } = response.data;
                         setStepsData(segment);
                         setInitStepsData(segment);
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    setIsLoading(false);
               });
     };
     useEffect(fetchSegmentDetail, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleHasChange = () => {
          dispatch(setRuleHaveEditting({ show: true, type: TYPE_SHOW_UNSAVE_CHANGE.EDIT_SIMPLE }));
     };

     return (
          <React.Suspense fallback={<CenterSpinner />}>
               <div className='rule-detail segment-detail'>
                    {isLoading ? (
                         <CenterSpinner />
                    ) : (
                         <div className='cvr-create-new'>
                              <h1>{id ? `Edit Segment: ${stepsData.name}` : `Create a Segment`}</h1>
                              <p>{id ? 'Use the steps below to configure your segment.' : 'Create your segment by following the steps below. '} </p>
                              <SegmentDetailContext.Provider
                                   value={{
                                        id,
                                        activeStep,
                                        setActiveStep,
                                        initStepsData,
                                        setInitStepsData,
                                        stepsData,
                                        setStepsData,
                                        handleHasChange,
                                        allSegmentObjectOptions,
                                   }}
                              >
                                   <SegmentRuleStep />
                                   <SegmentInfoStep />
                              </SegmentDetailContext.Provider>
                         </div>
                    )}
               </div>
          </React.Suspense>
     );
};


SegmentDetail.propTypes = {
     id: PropTypes.string,
};

export default SegmentDetail;
